export default __webpack_public_path__ + "static/media/deleteWhite.8b883022.svg";